module.exports = __webpack_public_path__ + "static/img/banner.2fa5d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect/banner.jpg
// module id = zjLM
// module chunks = 0